import Vue from 'vue'
import Vuex from 'vuex'
import { piezas } from './data.js'
import { placas } from './placas.js'
import { proveedores } from './proveedores.js'
import _ from 'lodash'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  state: {
    descripcion: '',
    cantidad: 0,
    canto1: 0,
    canto2: 0,
    canto3: 0,
    canto4: 0,
    largo: 0,
    ancho: 0,
    detalle: '',
    giro: 1,
    placa: 0,
    color_placa: '',
    color_canto: '',
    canto: 1,
    count: 0,
    piezas: piezas,
    placas: placas,
    proveedores: proveedores,
    cred: [],
    urlida: '',
    totalmt2: 0,
    totalmt2usd: 0,
    pedidos: [],
    categorias: [],
    max_largo: 2585,
    max_ancho: 1815,
    empresareferida: 0
  },
  getters: {
    islogin: (state, getters) => {
      if (getters.idactual > 0) {
        return true
      } else {
        return false
      }
    },
    idactual: state => {
      return state.cred[4665]
    },
    credactual: state => {
      return state.cred[5235]
    },
    url_empresa () {
      var path = window.location.href
      if (/(gabycar)/.test(path)) {
        return 141
      } else if (/(parana)/.test(path)) {
        return 151
      } else {
        return 1
      }
    },
    empresareferida: state => {
      return parseInt(state.empresareferida)
    },
    datosempresareferida: (state, getters) => {
      var empresa = getters.empresareferida
      var filtro = _.filter(state.proveedores, ['id', empresa])
      return filtro
    },
    datosproveedor: (state, getters) => (nro) => {
      var filtro = _.filter(state.proveedores, ['id', nro])
      return filtro[0]
    },
    accesodeplakcompleto: (state, getters) => {
      if (getters.empresareferida === '1' || getters.empresareferida === 1) {
        return true
      }
      return false
    },
    zonausuario: state => {
      if (state.cred[7867] === undefined) {
        return false
      } else {
        return state.cred[7867]
      }
    },
    mailusuario: state => {
      if (state.cred[7866] === undefined) {
        return false
      } else {
        return state.cred[7866]
      }
    },
    pedirdatos (state, getters) {
      if (getters.mailusuario === '' || getters.zonausuario === '') {
        return true
      } else {
        return false
      }
    },
    escarpintero: state => {
      if (_.size(state.cred[2006]) >= 1) {
        return true
      } else {
        return false
      }
    },
    nombreusuario: state => {
      return state.cred[7865]
    },
    urlsalida: state => {
      return state.urlida
    },
    cal_totalmt2: (state, getters) => (value) => {
      var total = 0
      _.forEach(value, function (value, key) {
        total = total + (((value.cantidad.valueOf() * (value.ancho.valueOf() * value.largo.valueOf()))) / 1000000)
      })
      return _.round(total, 2)
    },
    totalmt2: (state, getters) => {
      var total = getters.cal_totalmt2(getters.piezas)
      return total
    },
    totalmt2usd: (state, getters) => {
      return _.round(getters.totalmt2.valueOf() * 20, 2)
    },
    cal_totalmtl045: (state, getters) => (value) => {
      var total = 0
      _.forEach(value, function (value, key) {
        if (value.canto1 === 1) {
          total = total + ((value.cantidad.valueOf() * value.largo.valueOf()) / 1000)
        }
        if (value.canto2 === 1) {
          total = total + ((value.cantidad.valueOf() * value.largo.valueOf()) / 1000)
        }
        if (value.canto3 === 1) {
          total = total + ((value.cantidad.valueOf() * value.ancho.valueOf()) / 1000)
        }
        if (value.canto4 === 1) {
          total = total + ((value.cantidad.valueOf() * value.ancho.valueOf()) / 1000)
        }
      })
      return _.round(total, 2)
    },
    totalmtl045: (state, getters) => {
      var total = getters.cal_totalmtl045(getters.piezas)
      return _.round(total, 2)
    },
    totalmtl045usd: (state, getters) => {
      return _.round(getters.totalmtl045.valueOf() * 3, 2)
    },
    cal_totalmtl2: (state, getters) => (value) => {
      var total = 0
      _.forEach(value, function (value, key) {
        if (value.canto1 === 2) {
          total = total + ((value.cantidad.valueOf() * value.largo.valueOf()) / 1000)
        }
        if (value.canto2 === 2) {
          total = total + ((value.cantidad.valueOf() * value.largo.valueOf()) / 1000)
        }
        if (value.canto3 === 2) {
          total = total + ((value.cantidad.valueOf() * value.ancho.valueOf()) / 1000)
        }
        if (value.canto4 === 2) {
          total = total + ((value.cantidad.valueOf() * value.ancho.valueOf()) / 1000)
        }
      })
      return _.round(total, 2)
    },
    totalmtl2: (state, getters) => {
      var total = getters.cal_totalmtl2(getters.piezas)
      return _.round(total, 2)
    },
    totalmtl2usd: (state, getters) => {
      return _.round(getters.totalmtl2.valueOf() * 4, 2)
    },
    cal_totalmtcortes: (state, getters) => (value) => {
      var total = 0
      _.forEach(value, function (value, key) {
        total = total + (value.cantidad.valueOf() * ((value.ancho.valueOf() * 2) + (value.largo.valueOf() * 2)) / 1000)
      })
      return _.round(total, 2)
    },
    totalmtscorte: (state, getters) => {
      var total = getters.cal_totalmtcortes(getters.piezas)
      return _.round(total, 2)
    },
    estadocanto1: state => {
      return state.canto1.valueOf()
    },
    estadocanto2: state => {
      return state.canto2.valueOf()
    },
    estadocanto3: state => {
      return state.canto3.valueOf()
    },
    estadocanto4: state => {
      return state.canto4.valueOf()
    },
    giro: state => {
      return state.giro.valueOf()
    },
    descripcion: state => {
      return state.descripcion
    },
    cantidad: state => {
      return state.cantidad.valueOf()
    },
    largo: state => {
      return state.largo.valueOf()
    },
    ancho: state => {
      return state.ancho.valueOf()
    },
    detalle: state => {
      return state.detalle
    },
    piezavalida: (state, getters) => {
      if (getters.placa.valueOf() >= 1 && (getters.largo >= 50 && getters.largo <= getters.max_largo) && (getters.ancho >= 50 && getters.ancho <= getters.max_ancho) && getters.cantidad > 0) {
        return 1
      } else {
        return 0
      }
    },
    placa: state => {
      return state.placa
    },
    largo_placa: (state, getters) => {
      if (getters.placa !== 0) {
        return placas[getters.placa].largo
      }
    },
    ancho_placa: (state, getters) => {
      if (getters.placa !== 0) {
        return placas[getters.placa].ancho
      }
    },
    mm_placa: (state, getters) => {
      if (getters.placa !== 0) {
        return placas[getters.placa].mm
      }
    },
    color_placa: (state) => {
      return state.color_placa
    },
    color_canto: (state) => {
      return state.color_canto
    },
    canto: state => {
      return state.canto
    },
    max_largo: state => {
      return state.max_largo
    },
    max_ancho: state => {
      return state.max_ancho
    },
    piezas: state => {
      return state.piezas
    },
    cantidadpiezas: state => {
      return state.piezas.length
    },
    proximapieza: state => {
      return state.piezas.length + 1
    },
    descripcionproyecto: state => {
      return state.descripcion
    },
    pedidos: state => {
      return state.pedidos
    },
    categorias: state => {
      return state.categorias
    }
  },
  mutations: {
    CAMBIAR_CANTO_MUTATION: function (state, data) {
      if (data === 1) {
        if (this.getters.estadocanto1 === 2) {
          state.canto1 = 0
        } else {
          state.canto1++
        }
      }
      if (data === 2) {
        if (this.getters.estadocanto2 === 2) {
          state.canto2 = 0
        } else {
          state.canto2++
        }
      }
      if (data === 3) {
        if (this.getters.estadocanto3 === 2) {
          state.canto3 = 0
        } else {
          state.canto3++
        }
      }
      if (data === 4) {
        if (this.getters.estadocanto4 === 2) {
          state.canto4 = 0
        } else {
          state.canto4++
        }
      }
    },
    CAMBIAR_DESCRIPCION_MUTATION: function (state, data) {
      state.descripcion = data
    },
    CAMBIAR_CANTIDAD_MUTATION: function (state, data) {
      state.cantidad = data
    },
    CAMBIAR_LARGO_MUTATION: function (state, data) {
      state.largo = data
    },
    CAMBIAR_ANCHO_MUTATION: function (state, data) {
      state.ancho = data
    },
    CAMBIAR_DETALLE_MUTATION: function (state, data) {
      state.detalle = data
    },
    CAMBIAR_GIRO_MUTATION: function (state, data) {
      state.giro = data
    },
    CAMBIAR_COLOR_MUTATION: function (state, data) {
      state.color_placa = data
    },
    CAMBIAR_COLOR_CANTO_MUTATION: function (state, data) {
      state.color_canto = data
    },
    CAMBIAR_PLACA_MUTATION: function (state, data) {
      state.placa = data
    },
    CAMBIAR_CANTOT_MUTATION: function (state, data) {
      state.canto = data
    },
    VACIAR_PEDIDO_MUTATION: function (state, data) {
      this.state.descripcion = ''
      this.state.placa = 0
      this.state.canto = 1
      this.state.giro = 1
      this.state.color_placa = ''
      this.state.color_canto = ''
      this.state.max_largo = state.placas[1].max_largo
      this.state.max_ancho = state.placas[1].max_ancho
      this.state.piezas = []
    },
    VACIAR_PIEZA_MUTATION: function (state, data) {
      state.cantidad = ''
      state.canto1 = 0
      state.canto2 = 0
      state.canto3 = 0
      state.canto4 = 0
      state.ancho = ''
      state.largo = ''
      if (state.placa === 1) {
        state.giro = 1
      } else {
        state.giro = 0
      }
    },
    BLOQUEAR_ROTACION_MUTATION: function (state, data) {
      state.giro = data
    },
    PROCESAR_PIEZA_MUTATION: function (state) {
      let actuales = 1
      if (this.getters.cantidadpiezas >= 1) {
        actuales = _.maxBy(this.getters.piezas, function (o) { return o.id })
        actuales = actuales['id']
        actuales = ++actuales
      }
      var nuevapieza = {id: actuales, cantidad: this.getters.cantidad, largo: this.getters.largo, ancho: this.getters.ancho, canto1: this.getters.estadocanto1, canto2: this.getters.estadocanto2, canto3: this.getters.estadocanto3, canto4: this.getters.estadocanto4, giro: this.getters.giro, detalle: this.getters.detalle}
      state.piezas.push(nuevapieza)
    },
    AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION: function (state, data) {
      state.piezas.push(data)
    },
    ELIMINAR_PIEZA_MUTATION: function (state, index) {
      let piezas = this.getters.piezas
      let nuevas = piezas.filter(i => i.id !== index)
      this.state.piezas = nuevas
    },
    GUARDAR_PEDIDO_MUTATION: function (state) {
      console.log('guardo en local')
    },
    initialiseStore (state) {
      if (localStorage.getItem('store')) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        )
      }
    },
    SET_CREDENCIAL_MUTATION: function (state, data) {
      Vue.set(this.state.cred, data[0], data[1])
    },
    SET_EMPRESAREFERIDA_MUTATION: function (state, data) {
      this.state.empresareferida = data
    },
    SET_URL_VER_MUTATION: function (state, data) {
      this.state.urlida = data
    },
    SET_PEDIDOS_MUTATION: function (state, data) {
      this.state.pedidos = data
    },
    SET_CATEGORIAS_MUTATION: function (state, data) {
      this.state.categorias = data
    },
    MARCAR_PEDIDO_MUTATION: function (state, data) {
      let actual = _.filter(this.state.pedidos, function (o) { return o.id === data })
      Vue.set(actual, 'estado', 3)
      Vue.set(this.state.pedidos, data, actual)
    },
    CAMBIAR_MAX_LARGO_MUTATION: function (state, data) {
      this.state.max_largo = data
    },
    CAMBIAR_MAX_ANCHO_MUTATION: function (state, data) {
      this.state.max_ancho = data
    }
  },
  actions: {
    REINICIAR_PEDIDO: function (context) {
      context.commit('VACIAR_PEDIDO_MUTATION')
    },
    CAMBIAR_DESCRIPCION: function (context, data) {
      context.commit('CAMBIAR_DESCRIPCION_MUTATION', data)
    },
    CAMBIAR_CANTO: function (context, data) {
      context.commit('CAMBIAR_CANTO_MUTATION', data)
    },
    CAMBIAR_CANTIDAD: function (context, data) {
      context.commit('CAMBIAR_CANTIDAD_MUTATION', data)
    },
    CAMBIAR_LARGO: function (context, data) {
      context.commit('CAMBIAR_LARGO_MUTATION', data)
    },
    CAMBIAR_ANCHO: function (context, data) {
      context.commit('CAMBIAR_ANCHO_MUTATION', data)
    },
    CAMBIAR_DETALLE: function (context, data) {
      context.commit('CAMBIAR_DETALLE_MUTATION', data)
    },
    CAMBIAR_GIRO: function (context, data) {
      context.commit('CAMBIAR_GIRO_MUTATION', data)
    },
    CAMBIAR_COLOR: function (context, data) {
      context.commit('CAMBIAR_COLOR_MUTATION', data)
    },
    CAMBIAR_COLOR_CANTO: function (context, data) {
      context.commit('CAMBIAR_COLOR_CANTO_MUTATION', data)
    },
    CAMBIAR_PLACA: function (context, data) {
      context.commit('CAMBIAR_PLACA_MUTATION', data)
      if (data !== 0) {
        context.commit('CAMBIAR_MAX_LARGO_MUTATION', placas[data].max_largo)
        context.commit('CAMBIAR_MAX_ANCHO_MUTATION', placas[data].max_ancho)
      } else {
        context.commit('CAMBIAR_MAX_LARGO_MUTATION', placas[1].max_largo)
        context.commit('CAMBIAR_MAX_ANCHO_MUTATION', placas[1].max_ancho)
      }
      if (data > 1) {
        context.commit('BLOQUEAR_ROTACION_MUTATION', 0)
      } else {
        context.commit('BLOQUEAR_ROTACION_MUTATION', 1)
        context.commit('CAMBIAR_COLOR_MUTATION', 'Blanco')
      }
    },
    CAMBIAR_CANTOT: function (context, data) {
      context.commit('CAMBIAR_CANTOT_MUTATION', data)
    },
    VACIAR_PEDIDO: function (context, data) {
      context.commit('VACIAR_PIEZA_MUTATION')
      context.commit('VACIAR_PEDIDO_MUTATION')
      context.commit('BLOQUEAR_ROTACION_MUTATION', 1)
    },
    VACIAR_PIEZA: function (context, data) {
      context.commit('VACIAR_PIEZA_MUTATION')
    },
    PROCESAR_PIEZA: function (context, data) {
      if (this.getters.piezavalida === 1) {
        context.commit('PROCESAR_PIEZA_MUTATION')
        context.commit('VACIAR_PIEZA_MUTATION')
      }
    },
    AGREGAR_PIEZA_DE_BIBLIOTECA: function (context, data) {
      console.log(data)
      context.commit('AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION', data)
    },
    ELIMINAR_PIEZA: function (context, data) {
      context.commit('ELIMINAR_PIEZA_MUTATION', data)
    },
    PROCESAR_PEDIDO: function (context, data) {
      context.commit('GUARDAR_PEDIDO_MUTATION')
    },
    SET_CREDENCIALES: function (context, data) {
      _.forEach(data, function (value, key) {
        let data = []
        data[0] = key
        data[1] = value
        context.commit('SET_CREDENCIAL_MUTATION', data)
      })
    },
    SET_EMPRESAREFERIDA: function (context, data) {
      context.commit('SET_EMPRESAREFERIDA_MUTATION', data)
    },
    SET_URL_VER: function (context, data) {
      context.commit('SET_URL_VER_MUTATION', data)
    },
    SET_PEDIDOS: function (context, data) {
      context.commit('SET_PEDIDOS_MUTATION', data)
    },
    SET_CATEGORIAS: function (context, data) {
      context.commit('SET_CATEGORIAS_MUTATION', data)
    },
    MARCAR_PEDIDO: function (context, data) {
      context.commit('MARCAR_PEDIDO_MUTATION', data)
    }
  },
  modules: { },
  strict: debug
})
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(state))
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js